'use strict';

angular.module('myConsultApp')
	.filter('truncate', function () {
        return function (text, length, end) {
			console.log(text);
            if (isNaN(length))
                length = 10;

            if (end === undefined)
                end = "...";
			
			if(typeof text !== 'undefined'){
				if (text.length <= length || text.length - end.length <= length) {
					return text;
				}
				else {
					return String(text).substring(0, length-end.length) + end;
				}
			}
        };
    });
